var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYahooLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#6001d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m44.479 31.052-9.405 23.242-9.073-23.223a1.774 1.774 0 0 0-1.653-1.129H11.776a1.774 1.774 0 0 0-1.643 2.444l16.97 41.654-4.334 10.736a1.775 1.775 0 0 0 1.645 2.439h12.181c.723 0 1.374-.439 1.645-1.109l21.727-53.724a1.775 1.775 0 0 0-1.645-2.44H46.124a1.777 1.777 0 0 0-1.645 1.11zM74.38 13.893a1.775 1.775 0 0 1 1.645-1.109h12.199a1.775 1.775 0 0 1 1.645 2.44L76.981 46.97a1.775 1.775 0 0 1-1.645 1.109H63.155a1.774 1.774 0 0 1-1.645-2.439z",
    fill: "#6001d1",
    opacity: 1,
    "data-original": "#6001d1",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64.126,
    cy: 63.355,
    r: 9.854,
    fill: "#6001d1",
    opacity: 1,
    "data-original": "#6001d1",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahooLogo);
export default __webpack_public_path__ + "static/media/yahoo-logo.bef1922fa15d4da7df5b26bd49cf5b4d.svg";
export { ForwardRef as ReactComponent };